import { getCouponDetail } from "../api";
import * as DOMPurifyModule from "dompurify";
import { FormatDate } from "../utils/formatDate";
export default {
    name: "CouponInfo",
    props: {
        coupon_code: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            item: null,
            showModal: false,
            modalText: "",
        };
    },
    methods: {
        openModal(html) {
            const DOMPurify = DOMPurifyModule.default || DOMPurifyModule;
            this.modalText = DOMPurify.sanitize(html || "");
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.modalText = "";
        },
        onKeydown(e) {
            if (e.key === "Escape" && this.showModal) {
                this.closeModal();
            }
        },
        async getCouponDetailInitialDisplay(coupon_code) {
            const rspBody = await getCouponDetail(coupon_code);
            if (rspBody.result?.code === 9) {
                if (rspBody.result?.messages) {
                    this.$store.commit("setMessages", rspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
            }
            else {
                this.item = rspBody.data;
            }
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
    },
    mounted() {
        const couponCode = this.coupon_code;
        this.getCouponDetailInitialDisplay(couponCode);
        window.addEventListener("keydown", this.onKeydown);
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.onKeydown);
    },
};
